import homeLocale from './en.json'

const en = {
  home: homeLocale,
}

export default en
